<form [formGroup]="waterDeviceFG" class="component-container special-appliance-container">
  <div class="ui-g form-rows top-border relative-position">
    <div *ngIf="!isReadOnly && displayDeleteButton" class="top-right-position delete-icon">
      <div (click)="deleteComponent.emit()" class="pi pi-trash pointer-cursor"></div>
    </div>
  </div>

  <app-custom-fields formControlName="customFields" [applicationSection]="applicationSection" [isReadOnly]="isReadOnly"></app-custom-fields>
</form>
